import { Routes } from '@angular/router';
import { adminGuard } from '../../core/guards';

export const sportScoreboardPresetsRoutes: Routes = [
  {
    path: 'sport-scoreboard-presets',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/list/sport-scoreboard-preset-list.component').then(
            (m) => m.SportScoreboardPresetListComponent
          ),
      },
      {
        path: 'create',
        redirectTo: 'new',
        pathMatch: 'full',
      },
      {
        path: 'new',
        loadComponent: () =>
          import('./components/create/sport-scoreboard-preset-create.component').then(
            (m) => m.SportScoreboardPresetCreateComponent
          ),
        canActivate: [adminGuard],
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./components/detail/sport-scoreboard-preset-detail.component').then(
            (m) => m.SportScoreboardPresetDetailComponent
          ),
      },
      {
        path: ':id/edit',
        loadComponent: () =>
          import('./components/edit/sport-scoreboard-preset-edit.component').then(
            (m) => m.SportScoreboardPresetEditComponent
          ),
        canActivate: [adminGuard],
      },
    ],
  },
];
